import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, ArrowDownward, ViewCarousel } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";

class Index extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Pre ordering overzicht"} tKey={"preordering.pagetitle"} />}
        />
        <GridContainer>
          {this.props.vestiging_id ? (
            <GridItem xs={12}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Nieuwe Pre ordering"} tKey={"preordering.nieuw.item"} />
                </Button>
              </Link>
              <Link to={"./import"}>
                <Button className={classes.marginRight} color={"success"}>
                  <ArrowDownward className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Importeer"} tKey={"preordering.importeer"} />
                </Button>
              </Link>
            </GridItem>
          ) : null}
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "datetime", editable: false },
                { dbfield: "name", editable: false },
              ]}
              dbfields={"id,datetime,name"}
              delete={"preordering.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"preordering/:id/edit"}
              fetchUrl={"core/preordering"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                {
                  label: getTranslation("preordering.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("preordering.table.datum", "Datum"),
                  sortable: false,
                },
                {
                  label: getTranslation("preordering.table.omschrijving", "Omschrijving"),
                  sortable: false,
                },
              ]}
              reduxKey={"preordering"}
              tableTitle={<TranslationWrapper tDefault={"Preordering"} tKey={"preordering.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    filters: getVestigingFilterState(state, true),
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
